<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-tag"></i> 网站管理
                </el-breadcrumb-item>
				<el-breadcrumb-item>公司描述</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
			<el-form ref="form" :model="form">
				<quill-editor ref="descriptionEditor" v-model="form.content" :options="describeOption"></quill-editor>
			</el-form>
			<div style="margin-top:20px;text-align:right">
				<el-button @click="getData" v-if="controll['back']">还 原</el-button>
                <el-button type="primary" @click="saveEdit" v-if="controll['submit']">提 交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getControll } from '../../../utils/controlls';
import { getCompanyDescribe, saveEnumValue } from '../../../api/index';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import {quillRedefine} from 'vue-quill-editor-upload'
export default {
    name: 'describe',
    data() {
        return {
           form:{},
		   describeCode:1001,
		   imgPrefix:"/image",
		   controll:{}
        };
    },
	created() {
		this.controll = getControll('describe');
		let ckey = localStorage.getItem('ms_ckey');
		this.describeOption = quillRedefine({
			// 图片上传的设置
			uploadConfig: {
				action: this.imgPrefix + "/upload/" + ckey + "/17",  // 必填参数 图片上传地址
				res: (respnse) => {
					return this.imgPrefix + respnse.data
				},
				methods: 'POST',  // 可选参数 图片上传方式  默认为post
				//token: sessionStorage.token,  // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
				name: 'img',  // 可选参数 文件的参数名 默认为img
				size: 2048,  // 可选参数   图片限制大小，单位为Kb, 1M = 1024Kb
				accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon',  // 可选参数 可上传的图片格式
				placeholder: '产品描述',  // 可选参数 富文本框内的提示语
				//theme: '',  // 可选参数 富文本编辑器的风格
				//toolOptions: [],  // 可选参数  选择工具栏的需要哪些功能  默认是全部
				//handlers: {}  // 可选参数 重定义的事件，比如link等事件
			}
		}),
		this.getData();
    },
	components: {
		quillEditor,
		quillRedefine
	},
    methods: {
        getData() {
			getCompanyDescribe().then(res => {
				if (res.code == 0 ) {
					this.form = res.data;
				} else {
					this.$message.error("获取公司描述失败！" + res.message);
				}
			});
		},
		saveEdit() {
			this.form.enumCode = this.describeCode;
			saveEnumValue(this.form).then(res => {
				if (res.code == 0 ) {
					this.$message.success("保存公司描述成功！");
				} else {
					this.$message.error("保存公司描述失败！" + res.message);
				}
			});
		}
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
</style>
